import axios from 'axios'
import {
  handleOpenDownload,
  handleCloseDownload,
  changeDownloadProgress,
} from './handleDownload'
import downloader from './downloader'

export default function download(examinationId, type = 'download') {
  axios
    .post(`examinations/${examinationId}/download/file_name`, null, {})
    .then((r) => {
      const request = axios.CancelToken.source()
      const id = Math.random()
      const title = r.data
      handleOpenDownload({
        title,
        request,
        id,
      })
      axios
        .post(`examinations/${examinationId}/${type}`, null, {
          responseType: 'blob',
          cancelToken: request.token,
          headers: {
            Accept: '',
          },
          onDownloadProgress: (progressEvent) => {
            changeDownloadProgress(
              id,
              Math.round((progressEvent.loaded * 100) / progressEvent.total)
            )
          },
        })
        .then((res) => {
          downloader({
            data: res.data,
            name: r.data,
          })
          handleCloseDownload(id)
        })
        .catch(() => {
          handleCloseDownload(id)
        })
    })
}
